'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral([''], ['']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _Functions = require('../core/Functions');

var _Memoize = require('../core/Memoize');

var _Style = require('../core/Style');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getStyle = function getStyle(style, centerContent, width) {
  return centerContent ? _extends({}, style, { maxWidth: (0, _Style.remCalc)(width) }) : style;
};

var USE_CLASSES = {
  dark: '',
  light: 'private-overlay--light'
};

var Div = _styledComponents2.default.div.withConfig({
  displayName: 'UIOverlay__Div'
})(_templateObject);

var UIOverlay = function (_React$Component) {
  _inherits(UIOverlay, _React$Component);

  function UIOverlay(props) {
    _classCallCheck(this, UIOverlay);

    var _this = _possibleConstructorReturn(this, (UIOverlay.__proto__ || Object.getPrototypeOf(UIOverlay)).call(this, props));

    _this._getStyle = (0, _Memoize.memoizeLastResult)(getStyle);
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(UIOverlay, [{
    key: 'handleClick',
    value: function handleClick(evt) {
      var _props = this.props,
          onClick = _props.onClick,
          onOverlayClick = _props.onOverlayClick;
      var target = evt.target;

      (0, _Functions.callIfPossible)(onClick);
      var overlayContainsTarget = this._refEl && this._refEl.contains(target);
      if (!overlayContainsTarget || target === this._refEl) {
        (0, _Functions.callIfPossible)(onOverlayClick);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          centerContent = _props2.centerContent,
          children = _props2.children,
          className = _props2.className,
          contextual = _props2.contextual,
          __onClick = _props2.onClick,
          __onOverlayClick = _props2.onOverlayClick,
          style = _props2.style,
          tabIndex = _props2.tabIndex,
          use = _props2.use,
          width = _props2.width,
          rest = _objectWithoutProperties(_props2, ['centerContent', 'children', 'className', 'contextual', 'onClick', 'onOverlayClick', 'style', 'tabIndex', 'use', 'width']);

      var isSandboxed = contextual || this.context.sandboxed;

      var computedClassName = (0, _reactUtils.classNames)(className, 'private-overlay', 'uiOverlay-backdrop', USE_CLASSES[use], {
        'private-overlay--contextual': isSandboxed
      });

      var computedChildrenWrapperClassName = (0, _reactUtils.classNames)({
        'private-modal__container': centerContent
      });

      return _react2.default.createElement(
        Div,
        _extends({}, rest, {
          className: computedClassName,
          onClick: this.handleClick,
          tabIndex: isSandboxed ? null : tabIndex
        }),
        _react2.default.createElement(
          'div',
          {
            className: computedChildrenWrapperClassName,
            ref: function ref(_ref) {
              _this2._refEl = _ref;
            },
            style: this._getStyle(style, centerContent, width)
          },
          children
        )
      );
    }
  }]);

  return UIOverlay;
}(_react2.default.Component);

UIOverlay.propTypes = {
  centerContent: _react.PropTypes.bool.isRequired,
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  contextual: _react.PropTypes.bool.isRequired,
  onClick: _react.PropTypes.func,
  onOverlayClick: _react.PropTypes.func,
  style: _react.PropTypes.object,
  tabIndex: _react.PropTypes.number,
  use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)),
  width: _react.PropTypes.number.isRequired
};

UIOverlay.contextTypes = {
  sandboxed: _react.PropTypes.bool
};

UIOverlay.defaultProps = {
  centerContent: true,
  contextual: false,
  use: 'dark'
};

UIOverlay.Selector = Div;

exports.default = UIOverlay;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/overlay/UIOverlay.js
// module id = 329
// module chunks = 0